import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../../selectors/pages/vip20/bonuses/birthday_bonus';
import {} from '../../../../reducers/vip20/actions';
import ModalsInfoLib from '../../../../lib/modals-info';
import WhiteButton from '../../../components/white-button';
import ModalsLib from '../../../../lib/modals';
import BlocksCooldown from './cooldowns/blocks';

export default () => {
    const {bonus, level_preset, button} = useSelector(Selector),
          dispatch = useDispatch();

    return (
        <div className="vip-20-bonus vip-20-birthday-bonus">
            <div className="bonus-information">
                <div className="bonus-information-top">
                    <div className="information-container">
                        <div className="bonus-title">
                            Birthday Bonus
                        </div>
                        <div className="bonus-description">
                            It’s your day — claim your birthday reward and play big.
                        </div>
                    </div>

                    <div className="info-button" onClick={e => ModalsInfoLib.open('birthday-bonus')}>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10 20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 7.34784 18.9464 4.8043 17.0711 2.92893C15.1957 1.05357 12.6522 0 10 0C7.34784 0 4.8043 1.05357 2.92893 2.92893C1.05357 4.8043 0 7.34784 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C4.8043 18.9464 7.34784 20 10 20ZM10.5663 5.565C10.6405 5.63936 10.6994 5.72762 10.7396 5.82475C10.7798 5.92188 10.8004 6.02596 10.8004 6.13107C10.8003 6.23617 10.7795 6.34024 10.7393 6.43732C10.699 6.5344 10.64 6.6226 10.5656 6.69688C10.4913 6.77115 10.403 6.83006 10.3059 6.87023C10.2087 6.91039 10.1047 6.93104 9.99956 6.93098C9.89445 6.93092 9.79039 6.91016 9.69331 6.86989C9.59623 6.82961 9.50803 6.77061 9.43375 6.69625C9.28374 6.54607 9.19953 6.34245 9.19964 6.13018C9.19976 5.91792 9.2842 5.71439 9.43438 5.56437C9.58455 5.41436 9.78817 5.33015 10.0004 5.33027C10.2127 5.33039 10.4162 5.41482 10.5663 5.565ZM10.8 13.8688C10.8 14.0809 10.7157 14.2844 10.5657 14.4344C10.4157 14.5845 10.2122 14.6687 10 14.6687C9.78783 14.6687 9.58434 14.5845 9.43431 14.4344C9.28429 14.2844 9.2 14.0809 9.2 13.8688V9.27625C9.2 9.06408 9.28429 8.86059 9.43431 8.71056C9.58434 8.56054 9.78783 8.47625 10 8.47625C10.2122 8.47625 10.4157 8.56054 10.5657 8.71056C10.7157 8.86059 10.8 9.06408 10.8 9.27625V13.8688Z" fill="white"/>
                        </svg>
                    </div>
                </div>

                {!bonus.kyc_confirmed ? (
                    <div className="bonus-information-bottom">
                        <div className="bonus-button">
                            <WhiteButton className={"button"} onClick={e => {
                                ModalsLib.open("kyc_setup");
                            }}>Confirm Identity</WhiteButton>
                        </div>
                    </div>
                ) : (
                    <>
                        {bonus.cooldown ? (
                            <BlocksCooldown timeout_key={`birthday-bonus`} cooldown_timestamp={bonus.cooldown_timestamp} hoursOnly={false} />
                        ) : (
                            <></>
                        )}
                    </>
                )}

                {/* Claim button */}
                {/* <div className="bonus-information-bottom">
                    <div className="bonus-button">
                        <div className="button">
                            Claim bonus
                        </div>
                        <div className="button-timer">
                            7d 25m 25s
                        </div>
                    </div>
                </div> */}

                {/* Cooldown */}
                {/* <div className="bonus-information-bottom">
                    <div className="bonus-cooldown">
                        <div className="section">
                            <div className="value">364</div>
                            <span>days</span>
                        </div>
                        <div className="section">
                            <div className="value">19</div>
                            <span>hours</span>
                        </div>
                        <div className="section">
                            <div className="value">24</div>
                            <span>minutes</span>
                        </div>
                    </div>
                </div> */}
            </div>

            <div className="bonus-background">
                <div className="layer">
                    <div className="background"></div>
                </div>
                <div className="layer">
                    <div className="ellipse"></div>
                </div>
                <div className="layer">
                    <div className="bundler"></div>
                </div>
            </div>
        </div> 
    )
}